import { useTranslation } from 'react-i18next'

import { PolarAngleAxis, RadialBar, RadialBarChart } from 'recharts'
import { useTheme } from 'styled-components'

import { CardTitle, Text, Tooltip } from '@reveni-io/reveni-ui'

import AnimatedNumber from '@/common/components/AnimatedNumber/AnimatedNumber'

import { getColorByPercentage } from '../helpers'
import FooterMessage from './FooterMessage/FooterMessage'
import * as Styles from './styles'

const ScoreChart = ({ percentage, missingCount, onClick, title, titleIcon, tooltip }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const data = [{ value: Number(percentage), fill: getColorByPercentage(percentage, theme).normal }]

  return (
    <Tooltip
      title={
        <Text type="bodySRegular" color={theme.colors.text.inverse}>
          {tooltip}
        </Text>
      }
      backgroundColor={theme.colors.text.default}
    >
      <Styles.CardContainer onClick={onClick}>
        <Styles.Content>
          <CardTitle>
            <Styles.TitleContainer>
              {titleIcon}
              {title}
            </Styles.TitleContainer>
          </CardTitle>
          <Styles.ChartContainer>
            <Styles.ChartWrapper>
              <RadialBarChart
                width={150}
                height={150}
                cx="50%"
                cy="50%"
                innerRadius={55}
                outerRadius={70}
                barSize={10}
                startAngle={90}
                endAngle={-270}
                data={data}
              >
                <PolarAngleAxis type="number" domain={[0, 100]} tick={false} />
                <RadialBar dataKey="value" cornerRadius={10} background={{ fill: theme.colors.border.subtle }} />
              </RadialBarChart>
              <Styles.ChartCenter>
                <Text type="titleM">
                  <AnimatedNumber target={percentage} format="percent" />
                </Text>
                <Text type="bodyMBold">{t('Cumplimiento')}</Text>
              </Styles.ChartCenter>
            </Styles.ChartWrapper>
          </Styles.ChartContainer>
        </Styles.Content>
        <FooterMessage percentage={percentage} missingCount={missingCount} />
      </Styles.CardContainer>
    </Tooltip>
  )
}

export default ScoreChart
